import { InjectionToken } from '@angular/core';

import { LazyApiSyncInterceptor, LazyHttpClientInterceptor } from './model';

export const LAZY_HTTP_INTERCEPTOR     = new InjectionToken<LazyHttpClientInterceptor>('LAZY_HTTP_INTERCEPTOR');
export const LAZY_API_SYNC_INTERCEPTOR = new InjectionToken<LazyApiSyncInterceptor>('LAZY_API_SYNC_INTERCEPTOR');
